import { SearchConnectorsRequest } from '../../../core/cms-api/models';
import * as paginationConstants from '../../../shared/constants/pagination.constants';
import {
  Pagination,
} from '../../../shared/models/list.page.model';
import { ConnectorFilter } from '../store/connector.models';

export class ConnectorRequestUtil {
  static createConnectorListRequest(
    operatorId: string,
    pagination?: Pagination | null,
    filter?: ConnectorFilter | null
  ): SearchConnectorsRequest {
    return {
      operatorId: operatorId,
      pageIndex: pagination?.pageIndex ?? 0,
      pageSize: pagination?.pageSize ?? paginationConstants.DefaultPageSize,
      locationId: filter?.locationId,
      postalCodes: filter?.postalCodes,
      chargerIds: filter?.chargerIds,
      cities: filter?.cities,
      countries: filter?.countries,
      streets: filter?.streets,
      statuses: filter?.statuses,
      powerRangeMax: filter?.chargingPowers
        ? filter.chargingPowers[1]
        : undefined,
      powerRangeMin: filter?.chargingPowers
        ? filter.chargingPowers[0]
        : undefined,
      connectionStatuses: filter?.connectionStatuses,
      powerTypes: filter?.powerTypes,
    } as SearchConnectorsRequest;
  }

  
}
